/* Continue from Shopify's rendered success state, after PR 530 can consume it.
   The visible confirmation link remains usable if privacy/analytics is blocked. */
(function () {
  'use strict';
  var marker = document.querySelector('[data-ow-funnel-success]');
  if (!marker) return;
  var destination = marker.getAttribute('data-ow-funnel-success');
  if (!destination || destination.charAt(0) !== '/' || destination.charAt(1) === '/') return;
  var attempts = 0;
  function continueAfterTracking() {
    var tracker = document.querySelector('script[src*="ow-tracking.js"]');
    var ready = !tracker;
    if (tracker) {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function' && typeof privacy.saleOfDataAllowed === 'function') {
        if (!privacy.marketingAllowed() || !privacy.saleOfDataAllowed()) ready = true;
        else {
          try {
            var pending = JSON.parse(window.sessionStorage.getItem('ow-meta-pending-v1') || '{}');
            var key = window.location.pathname + ':contact-form';
            ready = !pending[key] && window.fbq && typeof window.fbq.callMethod === 'function';
          } catch (error) { ready = false; }
        }
      }
    }
    if (ready) {
      window.setTimeout(function () { window.location.assign(destination); }, 250);
    } else if (++attempts < 100) {
      window.setTimeout(continueAfterTracking, 100);
    }
  }
  if (document.readyState === 'complete') continueAfterTracking();
  else window.addEventListener('load', continueAfterTracking, { once: true });
})();
